import { theme } from '@Guidelines/Theme/theme';
import requestDocumentPanel from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Helpers/requestDocumentPanel';
import FieldValueDisplay from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/SectionTabs/SectionPanel/DocumentEntry/FieldCard/FIeldValueDisplay/FieldValueDisplay';
import FieldVerificationBadge from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Shared/FieldVerificationBadge';
import type DocumentFieldView from '@UI/Store/Documents/Views/DocumentFieldView';
import { css } from '@emotion/react';
import { ArrowRight } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const cardStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding: 0.875rem 1rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const headRowStyle = css`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
`;

const labelStyle = css`
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.semibold};
	color: ${theme.colors.ink};
`;

type Props = {
	readonly field: DocumentFieldView;
	readonly actionLabel: string;
};

/** A field seen from another object's panel: label, status, value, and the way to open its own panel. */
const FieldLinkCard: React.FC<Props> = ({ field, actionLabel }) => {
	const handleOpen = React.useCallback(() => {
		requestDocumentPanel({ type: 'field', fieldKey: field.key, occurrenceKey: null });
	}, [field.key]);

	return (
		<div css={cardStyle}>
			<div css={headRowStyle}>
				<span css={labelStyle}>{field.label}</span>
				<FieldVerificationBadge status={field.verification} />
			</div>
			<FieldValueDisplay field={field} />
			<Button
				type="button"
				text
				label={actionLabel}
				icon={<ArrowRight size={14} />}
				iconPos="right"
				onClick={handleOpen}
			/>
		</div>
	);
};

export default FieldLinkCard;
